<template>
    <div id="institutionAdmin">

        <div class="header">
            <!-- 面包屑导航 -->
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>自习室列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 搜索和添加 -->
        <div class="searchBox">
            <el-form :inline="true" style="margin-top: 20px;">
                <!-- <el-form-item>
                    <el-input size="small" v-model="keywords" placeholder="请输入用户姓名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size="small" v-model="keywords2" placeholder="请输入联系方法"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="btnSearch">搜索</el-button>
                </el-form-item> -->

                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-plus" @click="btnAddRoom">添加</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="content">
            <!--列表-->
            <el-table size="small" :data="roomList" highlight-current-row border element-loading-text="拼命加载中"
                style="width: 100%;" height="100%">

                <el-table-column align="center" show-overflow-tooltip prop="name" label="自习室名称" width="240">
                </el-table-column>
                <el-table-column align="center" show-overflow-tooltip prop="capacity" label="座位数量" width="160">
                </el-table-column>
                <el-table-column align="center" prop="auditStatus" label="状态">
                    <template slot-scope="scope">
                        <div>
                            <el-switch v-model="scope.row.state == 1 ? true : false" active-color="#13ce66"
                                inactive-color="#ff4949">
                            </el-switch>
                            {{ scope.row.state == 1 ? '开启' : '关闭' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="160" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="btnOperate(scope.row, 'modify')">修改</el-button>
                        <el-button size="mini" type="danger" @click="btnOperate(scope.row, 'delete')">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页组件 -->
        <!-- <div class="pageTurning">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div> -->

        <!-- 添加自习室 -->
        <el-dialog :title="pagesType == 'add' ? '添加自习室' : '编辑自习室'" :visible.sync="drawerShow" width="40%">
            <div class="addRoomBox">
                <el-form label-width="120px" :rules="formRules" ref="ruleForm" :model="fromData">
                    <el-form-item label="名称" prop="name">
                        <el-input v-model="fromData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="座位数量" prop="capacity">
                        <el-input v-model="fromData.capacity"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="state">
                        <el-radio v-model="fromData.state" label="1">启用</el-radio>
                        <el-radio v-model="fromData.state" label="0">禁用</el-radio>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="drawerShow = false">取 消</el-button>
                <el-button size="small" type="primary" @click="btnSubmitRoom">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

import Pagination from '../../components/Pagination'

import { addRoomApi, modifyRoomApi, deleteRoomApi, roomListApi } from '@/api/room_admin.js'

// 工具栏配置
const toolbarOptions = [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction

    [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],
    ["link", "image", "video"], // 对于图片上传这是重点
    ["clean"], // remove formatting button
];
export default {
    data() {
        return {
            drawerShow: false,
            pages: 0,
            fromData: {
                name: '', // 自习室名称
                capacity: '', // 座位数量
                state: '1', // 0禁用 1启用
            },
            formRules: {
                name: [
                    { required: true, message: '请输入自习室名称', trigger: 'blur' },
                ],
                capacity: [
                    { required: true, message: '请输入座位数量', trigger: 'blur' }
                ],
                state: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ],
            },
            roomList: [], // 自习室列表
            pagesType: 'add'
        }
    },
    created() {
        this.roomListData()
    },
    // 注册组件
    components: {
        Pagination
    },
    computed: {

    },
    methods: {
        // 点击搜索
        btnSearch() {
            let that = this
            that.pages = 0

        },
        // 点击添加自习室
        btnAddRoom() {
            this.drawerShow = true
            this.pagesType = 'add'
            this.fromData = {
                name: '', // 自习室名称
                capacity: '', // 座位数量
                state: '1', // 0禁用 1启用
            }
        },
        // 点击操作按钮
        btnOperate(item, type) {

            let that = this

            if (type == 'modify') {
                item.state = JSON.stringify(item.state)
                that.fromData = item
                this.pagesType = 'edit'
                this.drawerShow = true

            } else if (type == 'delete') {
                this.$confirm('确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    deleteRoomApi({
                        id: item.id
                    }).then(res => {
                        if (res.code == 200) {
                            this.$message.success('删除成功')
                            that.roomListData()
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            }

        },
        // 确定添加自习室
        btnSubmitRoom() {
            let that = this

            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    if (that.pagesType == 'add') {
                        addRoomApi({
                            ...that.fromData
                        }).then(res => {
                            if (res.code == 200) {
                                this.$message.success('添加成功')
                                that.drawerShow = false
                                that.roomListData()
                            } else {
                                this.$message.error(res.msg);

                            }
                        })
                    } else if (that.pagesType == 'edit') {

                        let newObj = {}

                        newObj['id'] = that.fromData.id
                        newObj['name'] = that.fromData.name
                        newObj['state'] = that.fromData.state
                        newObj['capacity'] = that.fromData.capacity

                        modifyRoomApi({
                            ...newObj
                        }).then(res => {
                            if (res.code == 200) {
                                this.$message.success('修改成功')
                                that.drawerShow = false
                                that.roomListData()
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    }

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 自习室列表 
        roomListData() {
            let that = this
            roomListApi({
                page: that.pages * 20
            }).then(res => {
                if (res.code == 200) {
                    that.roomList = res.data.list
                }
            })
        }
    }

}
</script>

<style>
#institutionAdmin {
    height: 100%;
    display: flex;
    flex-direction: column;
}

#institutionAdmin .header {
    flex: none;
}

#institutionAdmin .searchBox {
    flex: none;
}

#institutionAdmin .content {
    flex: auto;

}

#institutionAdmin .pageTurning {
    flex: none;
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/room_admin/room_list.vue